import React from 'react';
import { AppPermissionRequest } from '@Src/_basic/object/AppPermissionType';
import { Typography } from '@mui/material';

interface Props {
  row: AppPermissionRequest;
}
export default function EmailAddressColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.emailAddress}</Typography>;
}
